import isObject from './isObject';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function isKeyOfObject<T>(key: any, obj: T): key is keyof T {
  return isObject(obj) && !!key && obj.hasOwnProperty(key);
  // we will have to change our compiler lib to use es2022 to get performant Object.hasOwn
  // return isObject(obj) && !!key && Object.hasOwn(obj, key);
}
